import React from 'react';
import { memoize } from 'lodash/fp';
import REGEX from 'constants/regex';

const mentionTag = name => `<span class="Comment-mention">${name}</span>`;

const parseComment = memoize(body => {
  const mentionReplacer = (mention, userName) => mentionTag(userName);
  return body
    .replace(REGEX.MENTION, mentionReplacer) // wrap mentions in spans
    .replace(/\n/g, '<br />'); // add break tags
});

const Comment = props => (
  <div className="Comment">
    <div className="Comment-metadata">
      <div>{props.author}</div>
      <div>{moment(props.createdAt).calendar()}</div>
    </div>
    <div
      className="Comment-body"
      dangerouslySetInnerHTML={{ __html: parseComment(props.body) }}
    />
  </div>
);

export default Comment;
